import { render } from "./Main.vue?vue&type=template&id=0119e6f9&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=0119e6f9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0119e6f9"

export default script